var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-iframe-page"},[_c('a',{staticClass:"game-iframe-back",on:{"click":_vm.back}},[_c('img',{attrs:{"src":require("../../static/images/livequiz/back.png"),"alt":""}})]),_vm._v(" "),_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2689745a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/gameIframe.vue
// module id = null
// module chunks = 